import { render, staticRenderFns } from "./Posting.vue?vue&type=template&id=342c49d5&scoped=true"
import script from "./Posting.vue?vue&type=script&lang=js"
export * from "./Posting.vue?vue&type=script&lang=js"
import style0 from "./Posting.vue?vue&type=style&index=0&id=342c49d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c49d5",
  null
  
)

export default component.exports